import React from 'react';
import styled from 'styled-components';
const SVG = styled.svg `
  height: inherit;
  width: inherit;

  path {
    stroke: inherit;
  }
`;
export const DownArrowIcon = () => {
    return (React.createElement(SVG, { viewBox: "0 0 42 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M2.00003 2L21 21L40 2", stroke: "#1B1B1B", strokeWidth: "3" })));
};
